import {
  ActionDefinition,
  AutomationAction,
  CreateAutomationActionRequest,
  UpdateAutomationActionRequest,
  Team,
} from '../types/actions';
import { apiOrchestrator } from 'services/apiService';

export const actionsApi = {
  // Action Definitions
  getActionDefinitions: async (): Promise<ActionDefinition[]> => {
    console.log('🔍 Buscando definições de ações...');
    const response = await apiOrchestrator.get<ActionDefinition[]>(
      '/automations/action-definitions'
    );
    console.log('✅ Definições de ações carregadas:', response.data);
    return response.data;
  },

  getActionDefinition: async (uuid: string): Promise<ActionDefinition> => {
    console.log(`🔍 Buscando definição de ação: ${uuid}`);
    const response = await apiOrchestrator.get<ActionDefinition>(
      `/automations/action-definitions/${uuid}`
    );
    console.log('✅ Definição de ação carregada:', response.data);
    return response.data;
  },

  // Automation Actions - Buscar via endpoint principal da regra
  getActionsByRule: async (ruleUuid: string): Promise<AutomationAction[]> => {
    console.log(`🔍 Buscando ações da regra: ${ruleUuid}`);
    const response = await apiOrchestrator.get(`/automations/rules/${ruleUuid}`);
    console.log('✅ Regra carregada:', response.data);

    // Extrair ações do response da regra
    const actions = response.data.actions || [];
    console.log('✅ Ações extraídas da regra:', actions);
    return actions;
  },

  createAction: async (data: CreateAutomationActionRequest): Promise<AutomationAction> => {
    console.log('🔍 === INÍCIO createAction ===');
    console.log('🔍 Dados da ação:', data);
    console.log('🔍 URL:', '/automations/actions');

    try {
      const response = await apiOrchestrator.post<AutomationAction>('/automations/actions', data);
      console.log('✅ Ação criada com sucesso:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao criar ação:', error);
      console.error('❌ Dados enviados:', data);
      throw error;
    }
  },

  updateAction: async (
    uuid: string,
    data: UpdateAutomationActionRequest
  ): Promise<AutomationAction> => {
    console.log(`🔍 Atualizando ação ${uuid}:`, data);
    const response = await apiOrchestrator.patch<AutomationAction>(
      `/automations/actions/${uuid}`,
      data
    );
    console.log('✅ Ação atualizada:', response.data);
    return response.data;
  },

  deleteAction: async (uuid: string): Promise<void> => {
    console.log(`🔍 Deletando ação: ${uuid}`);
    await apiOrchestrator.delete(`/automations/actions/${uuid}`);
    console.log('✅ Ação deletada');
  },

  deleteAllActions: async (ruleUuid: string): Promise<void> => {
    console.log(`🔍 Deletando todas as ações da regra: ${ruleUuid}`);

    try {
      // Buscar todas as ações da regra
      const actions = await actionsApi.getActionsByRule(ruleUuid);
      console.log(`📋 Encontradas ${actions.length} ações para deletar`);

      if (actions.length === 0) {
        console.log('ℹ️ Nenhuma ação encontrada para deletar');
        return;
      }

      // Deletar ações em paralelo, ignorando erros 404
      const deletePromises = actions.map(async action => {
        try {
          await actionsApi.deleteAction(action.uuid);
        } catch (error: any) {
          if (error.response?.status === 404) {
            console.log(`⚠️ Ação ${action.uuid} já foi deletada (404)`);
          } else {
            throw error;
          }
        }
      });

      await Promise.allSettled(deletePromises);
      console.log('✅ Todas as ações foram deletadas');
    } catch (error) {
      console.error('❌ Erro ao deletar ações:', error);
      throw error;
    }
  },

  // Teams (reutilizado da V1)
  getTeams: async (): Promise<Team[]> => {
    console.log('🔍 Buscando equipes...');
    const response = await apiOrchestrator.get<Team[]>('/team/');
    console.log('✅ Equipes carregadas:', response.data);
    return response.data;
  },

  getTeam: async (uuid: string): Promise<Team> => {
    console.log(`🔍 Buscando equipe: ${uuid}`);
    const response = await apiOrchestrator.get<Team>(`/team/${uuid}`);
    console.log('✅ Equipe carregada:', response.data);
    return response.data;
  },
};
